// extracted by mini-css-extract-plugin
export default {"header":"header-BgcoB","title":"title-A4G6e","backBtn":"backBtn-uIS37"};